import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import type { CreateAsnDTO } from '@invenco/supply-interface';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/core/card';
import { Form } from '@/components/core/form';
import { WizardStep } from '@/components/wizard';
import type { WizardStepDefinition } from '@/components/wizard/wizard-context';
import { useIsFormValid } from '@/shared/hooks/use-is-form-valid';

import {
  AsnAddressFields,
  asnAddressFieldsDefaultValues,
  asnAddressFieldsSchema,
} from '../asn-address-fields';

export function AddressStep({
  step,
  onChange,
}: {
  step: WizardStepDefinition;
  onChange: (input: Partial<CreateAsnDTO>) => void;
}) {
  const form = useForm({
    resolver: zodResolver(asnAddressFieldsSchema),
    defaultValues: asnAddressFieldsDefaultValues,
  });
  const isValid = useIsFormValid(form, asnAddressFieldsSchema);

  const submitSection = async () => {
    let valid = false;

    await form.handleSubmit((data) => {
      onChange({
        fromAddress: {
          companyName: data.companyName || undefined,
          contactName: data.contactName,
          contactNumber: data.contactNumber || undefined,
          contactEmail: data.contactEmail || undefined,
          address1: data.address1,
          address2: data.address2 || undefined,
          city: data.city || undefined,
          state: data.state || undefined,
          postcode: data.postcode || undefined,
          country: data.country,
        },
      });
      valid = true;
    })();

    return valid;
  };

  return (
    <WizardStep step={step} complete={isValid} onSubmitStep={submitSection}>
      <Card aria-label="From address">
        <CardHeader>
          <CardTitle>From address</CardTitle>
        </CardHeader>
        <CardContent>
          <Form {...form}>
            <div className="space-y-4">
              <AsnAddressFields />
            </div>
          </Form>
        </CardContent>
      </Card>
    </WizardStep>
  );
}
